import axios, { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import router from '@/router'
import {
  transformKeysToCamelCase,
  transformKeysToSnakeCase
} from '@/utils/transform-keys'

const getAuthToken = (): string | undefined => {
  const token = localStorage.getItem('token')
  return token ? `Bearer ${token}` : undefined
}

const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '/api/v1' : 'http://localhost:8000/api/v1/',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
})

export { api, getAuthToken }

api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = getAuthToken()
  if (token) {
    config.headers.Authorization = token
  }

  if (config.data && !(config.data instanceof FormData)) {
    config.data = transformKeysToSnakeCase(config.data)
  }

  if (config.params) {
    config.params = transformKeysToSnakeCase(config.params)
  }

  return config
})

api.interceptors.response.use(
  (response: AxiosResponse) => {
    response.data = transformKeysToCamelCase(response.data)
    return response
  },
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      router.push('/application')
    }
    return Promise.reject(error)
  }
)